<template>
  <div>
    <div class="text-right p-2">
      <button
        @click="save"
        class="btn btn-sm btn-dark"
      >Save Rates</button>
    </div>
    <table class="table">
      <tbody>
        <tr
          v-for="rate in rates"
          :key="rate.id"
        >
          <td>{{ rate.id }}</td>
          <td>{{ rate.code.toUpperCase() }}</td>
          <td>{{ rate.name }}</td>
          <td>
            <input
              style="width: 100px;"
              type="number"
              class="form-control form-control-sm"
              v-model="client.rates[rate.id]"
            />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
// import VueSelect from 'vue-select'
// import Dropzone from 'vue2-dropzone'
// import 'vue2-dropzone/dist/vue2Dropzone.min.css'

// import clientStore from '@/stores/clients'
// import product from '@/libs/product'
// import auth from '@/libs/auth'

import api from '@/api'
// import productStore from '@/stores/products'
import n from '@/libs/notifications'


export default {
  name: 'client-rates',

  props: ['client'],

  components: {
    // VueSelect,
    // Dropzone 
  },

  data() {
    return {
      rates: [],
    }
  },

  created() {
    this.fetchData()
  },

  computed: {

  },

  methods: {
    save() {
      api.post(`/clients/${this.client.id}/rates`, { rates: this.client.rates }).then(() => {
        n.success('Rates Saved.')
      })
    },

    fetchData() {
      api.get('/rates').then(res => {
        this.rates = res.data.rates
      })
    }
  }
}
</script>

<style scoped>
.modal-body {
  max-height: calc(90vh - 200px);
  overflow-y: auto;
}
</style>